<div id="small-overlay" [ngStyle]="{'height': height, 'width': width, 'left': overrideLeft, 'top': overrideTop }" [ngClass]="{'apply': applyOverlay}">
  <div style="width:100%;height:100%;margin:auto;">
      <i class="fa fa-spinner spin-frames"></i>
  </div>
</div>